import { Api } from "../config/request";

export default {
  getNamespaces(queryParams) {
    return Api.get(
      `/feature-config/namespace${
        queryParams && queryParams.length > 0 ? `${queryParams}` : ""
      }`
    );
  },
  upsertNamespace(payload) {
    return Api.put("/feature-config/namespace", payload);
  },
  syncNamespace(payload) {
    return Api.put("/feature-config/sync-namespace", payload);
  },
  getNamespaceVersions(namespace) {
    return Api.get(`/feature-config/namespace/${namespace}/versions`);
  },
};
